import { Controller } from "stimulus"
import Rails from '@rails/ujs'

export default class extends Controller {
  static targets = ['textPreview', 'editor', 'editorButton', 'previewButton', 'markupButtons']

  showEditor() {
    this.toggleControls()
  }

  toggleControls() {
    this.textPreviewTarget.classList.toggle('display-none')
    this.editorTarget.classList.toggle('display-none')

    this.editorButtonTarget.classList.toggle('active')
    this.previewButtonTarget.classList.toggle('active')
    this.markupButtonsTarget.classList.toggle('display-none')
  }

  showPreview() {
    Rails.ajax({
      type: "post",
      url: '/preview',
      data: new URLSearchParams({ text: this.editorTarget.value }).toString(),
      success: (response)=> {
        this.textPreviewTarget.innerHTML = response.body.innerHTML

        this.toggleControls()
      }
    })
  }
}
